import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import Profile from './Profile';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';
import messages from '../../locale/messages';

export default async function action({ params, intl, store }) {
  const title = intl?.formatMessage(messages.userProfile);
  const data = store.getState().account.data;
  const isAuthenticated = store.getState().runtime.isAuthenticated;
  const profileId = params.profileId;
  let profile = 0, isUser = false;

  if (profileId) {
    profile = Number(profileId);
    if (isAuthenticated && data && Number(data.profileId) == Number(profileId)) {
      profile = Number(profileId);
      isUser = true;
    }
  }

  const hasPhoneNumber = store.getState().account.data?.phoneNumber
  let isSuperAdmin = store.getState().runtime.isSuperAdmin;

  if (!hasPhoneNumber && typeof window !== 'undefined' && !isSuperAdmin) {
    alert("Por favor agregue su número de teléfono")
    return { redirect: '/user/edit' };
  }

  const profileComponent = (
    <Profile
      title={title}
      isUser={isUser}
      profileId={profile}
    />
  );

  return {
    title,
    component:
      <UserLayout hideMenu>
        {isAuthenticated ? (
          <DashboardLayout>
            {profileComponent}
          </DashboardLayout>
        ) : profileComponent}
      </UserLayout>,
  };

};
